import React, { JSX } from "react";
import { CompetitiveInsightsManageAddModal } from "@app/overviews/network-benchmarking-dashboard/manage/CompetitiveInsightsManageAddModal";
import CompetitiveInsightsManageContextProvider from "@app/overviews/network-benchmarking-dashboard/manage/CompetitiveInsightsManageContext";
import CompetitiveInsightsManageFilters from "@app/overviews/network-benchmarking-dashboard/manage/CompetitiveInsightsManageFilters";
import CompetitiveInsightsManageTable from "@app/overviews/network-benchmarking-dashboard/manage/CompetitiveInsightsManageTable";

const CompetitiveInsightsManage = (): JSX.Element => {
  return (
    <CompetitiveInsightsManageContextProvider>
      <CompetitiveInsightsManageContent />
    </CompetitiveInsightsManageContextProvider>
  );
}

const CompetitiveInsightsManageContent = (): JSX.Element => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12 d-flex justify-content-between align-items-center mb-3">
          <label className="header-s mb-0">
            Super Project Management
          </label>
          <CompetitiveInsightsManageAddModal mode="add" />
        </div>
      </div>
      <CompetitiveInsightsManageFilters />
      <div className="row">
        <div className="col-12">
          <CompetitiveInsightsManageTable />
        </div>
      </div>
    </React.Fragment>
  );
}

export default CompetitiveInsightsManage;
